import { Link } from "react-router-dom";
import Logo from "@/components/feature/Logo";

export default function ProductsFooter() {
  return (
    <footer className="relative bg-background-50 border-t border-background-300/20">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center">
          <Logo imgClassName="h-6" />
        </div>
        <div className="flex items-center gap-6">
          <Link
            to="/"
            className="text-xs text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
          >
            Home
          </Link>
          <Link
            to="/products"
            className="text-xs text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
          >
            Products
          </Link>
        </div>
        <p className="text-xs text-foreground-600">
          © {new Date().getFullYear()} Joble. All rights reserved.
        </p>
      </div>
    </footer>
  );
}